export class UserModel {

    Id:number;
    Name:string;
    Surname:string;
    Username:string;
    Email:string;
    Phone:string;
    Workplace:string;
    LastLogin:string;
    Deactivated:boolean;
    RightsFormModel:RightsFormModel;
    GroupsModel:GroupsFormModel;
}

export class GroupsFormModel{
    Groups:GroupformItemModel[];
}

export class GroupformItemModel{

    Id:number;
    Name:string;
    Selected:boolean;
}

export class RightsFormModel{
    Rights:RightFormItem[];
}

export class RightFormItem{
    Id:number;
    Description:string;
    AssignedValue:string;
    InnerAssignedValue:string;
    ValueDescription:string;
    AllowSelected:boolean;
    DenySelected:boolean;
    Children:RightFormItem[];

    constructor(){
          this.DenySelected = false;
    }
}